import type React from 'react'
import styled from 'styled-components'

import { LockFilledIcon, LockOpenIcon } from '@components/ui/svgIcons'
import { Switch, SWITCH_CSS_VARIABLES } from '@components/ui/Switch'

const StyledSwitch = styled(Switch)`
  ${SWITCH_CSS_VARIABLES.trackColor}: ${({ theme }) => theme.colors.primary[50]};
  ${SWITCH_CSS_VARIABLES.checkedTrackColor}: ${({ theme }) => theme.colors.primary[50]};
  ${SWITCH_CSS_VARIABLES.thumbColor}: ${({ theme }) => theme.colors.gray[102]};
  ${SWITCH_CSS_VARIABLES.checkedThumbColor}: ${({ theme }) => theme.colors.gray[102]};
  ${SWITCH_CSS_VARIABLES.baseBackgroundColor}: ${({ theme }) => theme.colors.primary[50]};
  ${SWITCH_CSS_VARIABLES.hoverRingColor}: ${({ theme }) => theme.colors.primary[50]};
  ${SWITCH_CSS_VARIABLES.checkedHoverRingColor}: ${({ theme }) => theme.colors.primary[50]};

  padding: 6px 10px;
  width: 52px;
  height: 26px;
  margin-right: 10px;

  & > span:first-child {
    margin: 3px 5px;
    width: 20px;
    height: 20px;
    font-size: 12px;

    &:hover {
      transform: scale(1.1);
    }

    &[data-checked='true'] {
      transform: translateX(20px);

      &:hover {
        transform: translateX(20px) scale(1.1);
      }
    }
  }
`

interface LockToggleButtonProps {
  checked: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
}

export function LockToggleButton({ checked, onChange }: LockToggleButtonProps) {
  return (
    <StyledSwitch
      checked={checked}
      onChange={onChange}
      icon={<LockFilledIcon size={12} />}
      checkedIcon={<LockOpenIcon size={12} />}
    />
  )
}
